import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { B2BProductPricingVariables } from '../models/b2b-product-pricing-variables.model';
import { ProductPricingResponse } from '../models/product-pricing-response.model';

@Injectable({
  providedIn: 'root',
})
export class B2BProductPricingGQL extends Query<ProductPricingResponse, B2BProductPricingVariables> {
  override document = gql`
    query (
      $accountNumber: NonEmptyString!
      $jobQuoteName: String
      $quantity: Int
      $sku: NonEmptyString!
      $storeNumber: String
      $exportCatalogSku: String!
      $tintingFeeSku: String
      $unitOfMeasurements: String
    ) {
      customerProductPrice(
        customerProductPriceInput: {
          accountNumber: $accountNumber
          jobQuoteName: $jobQuoteName
          quantity: $quantity
          sku: $sku
          storeNumber: $storeNumber
          exportCatalogSku: $exportCatalogSku
          tintingFeeSku: $tintingFeeSku
          unitOfMeasurements: $unitOfMeasurements
        }
      ) {
        sku
        exportCatalogSku
        quantity
        currencyCode
        netPricePerUnit
        netPricePerUnitBeforePromotions
        discountedUnitPrice
        grossPricePerUnit
        discountedUnitGrossPrice
        totalNetPrice
        totalNetPriceBeforePromotions
        totalGrossPrice
        grossPricePerPricingUnit
        netPricePerPricingUnit
        pricingUnitOfMeasure
        customerDiscountAmount
        customerDiscountPercentage
        totalPromotionDiscountAmount
        totalPromotionDiscountPercentage
        promotionEffects {
          description
          discountAmount
          isCouponDiscount
        }
        pricingServiceItems {
          tintingFee {
            sku
            netPricePerUnit
            totalNetPrice
            totalGrossPrice
            grossPricePerUnit
            currencyCode
            errorCode
          }
        }
      }
    }
  `;
}
